import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("oc-modal")
export class OCModal extends LitElement {
  @property()
  content = "<small>no-content</small>";

  @property()
  acceptCallback = null;

  constructor() {
    super();
    this.addEventListener("click", () => removeFromDom(this));
    prepareBody();
  }

  static get styles() {
    return css`
      :host {
        position: absolute;
        height: 100vh;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.75);
        z-index: 1000000;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .midContainer {
        width: 75%;
        background-color: white;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
        transition: 0.3s;
        border-radius: 5px; /* 5px rounded corners */
        padding: 20px;
      }

      .buttonWrapper {
        width: 100%;
        display: flex;
        justify-content: flex-end;
      }

      .submitButton {
        cursor: pointer;
        padding: 5px;
        border: 1px solid transparent;
        border-radius: 2px;
      }

      .submitButton:hover {
        border: 1px solid lightgrey;
      }
    `;
  }

  render() {
    return html`<div @click=${(e) => e.stopPropagation()} class="midContainer">
      ${toElement(this.content)}
      <div class="buttonWrapper">
        <div class="submitButton" @click=${() => removeFromDom(this)}>
          Schließen
        </div>
        ${this.acceptCallback
          ? html`<div class="submitButton" @click=${() => this.acceptCallback(this)}>
              OK
            </div>`
          : ""}
      </div>
    </div>`;
  }
}

function removeFromDom(element) {
  const body = document.body;
  body.classList.remove("stop-scrolling");
  element.remove();
}

function toElement(
  s = "",
  c,
  t = document.createElement("template"),
  l = "length"
) {
  t.innerHTML = s.trim();
  c = [...t.content.childNodes];
  return c[l] > 1 ? c : c[0] || "";
}

function prepareBody() {
  const body = document.body;
  body.classList.add("stop-scrolling");
}
